import WhatsIcon from "./icons/WhatsIcon";

const WHATSAPP_URL = "https://wa.me/201288736158";

export default function FloatingWhatsApp() {
	if (!WHATSAPP_URL) return null;

	return (
		<a
			href={WHATSAPP_URL}
			target="_blank"
			rel="noopener noreferrer"
			className="floating-whatsapp"
			aria-label="Chat on WhatsApp"
		>
			<WhatsIcon />
		</a>
	);
}
